<template lang="pug">
.container.grid-xl.py-2.manual-page
  .columns
    .column.col-12
      router-link.btn.btn-link.btn-sm(:to="{ name: 'app.manuais' }")
        i.fa.fa-arrow-left.fa-fw
        |  Voltar aos manuais

      h4.h4 Indicadores — Análises
      p.text-gray Manual do usuário · OS-m Admin v1.84+

      h5.h5 Visão geral
      p
        | Em
        strong  Indicadores → Análises
        |  você escolhe um relatório sobre análises (situação, mês, analista),
        |  aplica filtros e imprime o resultado.

      h5.h5 1. Abrir o hub
      ol
        li No menu lateral, abra
          strong  Indicadores
          | .
        li Clique em
          strong  Análises
          | .
      p Aparecem os cards dos relatórios disponíveis (conforme sua permissão).
      figure.manual-figure
        img(:src="imgHub" alt="Hub de indicadores de Análises")

      h5.h5 2. Abrir e filtrar um relatório
      ol
        li Clique no card desejado (ex.:
          strong  Por situação
          | ).
        li Em
          strong  Filtrar
          | , ajuste datas e demais critérios.
        li Clique no ícone de
          strong  funil
          |  para aplicar.
        li Use o ícone de
          strong  impressora
          |  para imprimir a tela.
      figure.manual-figure
        img(:src="imgReport" alt="Relatório Análises por situação")

      h5.h5 3. Relatórios disponíveis
      ul
        li
          strong  Situações por mês
          |  — análises agrupadas por situação e mês.
          |  Permissão:
          strong  Indicadores → Análises → Situações por meses
          | .
        li
          strong  Por situação
          |  — quantidade por situação.
          |  Permissão:
          strong  Indicadores → Análises → Situações
          | .
        li
          strong  Analistas por mês
          |  — análises por analista e mês.
          |  Permissão:
          strong  Indicadores → Análises → Analistas por meses
          | .

      .divider
      router-link.btn.btn-primary(:to="{ name: 'app.manuais' }")
        i.fa.fa-book.fa-fw
        |  Voltar à lista de manuais
</template>

<script>
export default {
  data() {
    return {
      imgHub: require("@/assets/manuais/29-indicadores-analises-hub.png"),
      imgReport: require("@/assets/manuais/29a-indicadores-analises-por-situacao.png"),
    }
  },
}
</script>

<style lang="stylus" scoped>
.manual-page
  h5
    margin-top 1.5rem

  .manual-figure
    margin 1rem 0
    img
      max-width 100%
      height auto
      border 1px solid #e7e9ed
      border-radius 4px
</style>
